const mpSdk = {
    /**
     * 查看可以调用哪些方法 https://developers.weixin.qq.com/miniprogram/dev/component/web-view.html
     * @param method
     * @param params
     * @returns {Promise<unknown>}
     */
    call(method, params) {
        return new Promise((resolve, reject) => {
            if (!window.wx || !window.wx.miniProgram || typeof window.wx.miniProgram[method] !== 'function') {
                reject(new Error('需要在微信小程序环境下调用该方法'));
                return;
            }

            window.wx.miniProgram[method]({
                ...params,
                success: resolve,
                fail: reject,
            });
        });
    },
};

export default mpSdk;
